<script setup lang="ts">
import { HTMLAttributes } from 'vue';

defineProps</* @vue-ignore */ HTMLAttributes>();
</script>
<template>
  <svg viewBox="0 0 140 43" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0H20.515C28.1698 0 33.3751 4.11571 33.3751 11.18C33.3751 15.8486 31.3543 18.4286 29.2109 19.9643V20.21C32.7015 21.8686 34.9673 24.94 34.9673 30.5914C34.9673 38.4543 29.7008 43 21.3111 43H0V0ZM19.1065 16.5857C22.3521 16.5857 23.6382 14.8657 23.6382 12.5314C23.6382 10.1971 22.3521 8.47714 19.1065 8.47714H9.55325V16.5857H19.1065ZM19.7189 34.4614C23.8219 34.4614 25.1691 32.25 25.1691 29.67C25.1691 27.52 23.8831 24.94 19.7189 24.94H9.55325V34.4614H19.7189Z"
    />
    <path d="M40.785 0H50.3995V34.4H69.8734V43H40.785V0Z" />
    <path
      d="M74.7705 0H94.2444C103.004 0 108.393 6.20429 108.393 14.19C108.393 22.4214 102.881 28.6257 94.2465 28.6257H84.387V43H74.7725V0H74.7705ZM92.3481 20.0257C96.4511 20.0257 98.5944 18.1214 98.5944 14.19C98.5944 10.5043 96.2674 8.53857 92.3481 8.53857H84.387V20.0257H92.3481Z"
    />
    <path
      d="M134.695 21.4816C134.246 20.7014 133.143 20.0626 132.245 20.0626H122.308C121.41 20.0626 120.308 20.7014 119.859 21.4816L114.89 30.1123C114.441 30.8924 114.441 32.1701 114.89 32.9503L119.859 41.581C120.308 42.3611 121.41 43 122.308 43H132.245C133.143 43 134.246 42.3611 134.695 41.581L139.663 32.9503C140.112 32.1701 140.112 30.8924 139.663 30.1123L134.695 21.4816Z"
    />
  </svg>
</template>
<style scoped>
svg {
  padding: var(--nxt-space-md);
  fill: none;
}

path {
  fill: var(--nxt-brand-bg);
}
</style>
